import { compose, createStore, applyMiddleware } from "redux";
import { createBrowserHistory } from "history";
import { createEpicMiddleware } from "redux-observable";
import { createReduxHistoryContext } from "redux-first-history";
import rootEpic from "root/rootEpic";
import createRootReducer from "root/rootReducer";
import persistAuthData from "./auth/authMiddleware";

// Module scope so the HMR reducer closure below reuses the same routerReducer.
const {
  createReduxHistory,
  routerMiddleware,
  routerReducer,
} = createReduxHistoryContext({ history: createBrowserHistory() });

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const epicMiddleware = createEpicMiddleware();

const configureStore = () => {
  const store = createStore(
    createRootReducer(routerReducer),
    composeEnhancers(
      applyMiddleware(routerMiddleware, epicMiddleware, persistAuthData),
    ),
  );

  if (module.hot) {
    module.hot.accept("root/rootReducer", () => {
      const createRootReducer = require("root/rootReducer").default;
      store.replaceReducer(createRootReducer(routerReducer));
    });
  }

  epicMiddleware.run(rootEpic);
  // Must come after the store exists; epics are running first so they observe
  // the initial LOCATION_CHANGE this sync dispatches.
  const history = createReduxHistory(store);
  return { store, history };
};

if (module.hot) {
  module.hot.accept("root/rootEpic", () => {
    const rootEpic = require("root/rootEpic").default;
    epicMiddleware.replaceEpic(rootEpic);
  });
}

export default configureStore;
